import { InputTextAreaField } from '@tempmee/react';
import type { InputTextAreaFieldProps } from '@tempmee/react';

/**
 * App-level wrapper around the DS InputTextAreaField.
 *
 * Overrides the global `textarea {}` rule in registration.scss
 * (border: 2px solid #3DAFC9) which leaks onto every textarea in the app.
 * Once that rule is removed, this wrapper is still useful as the canonical
 * way to render a DS textarea with a sensible default height.
 *
 * Implementation note: InputTextAreaField internally does:
 *   <textarea style={height !== void 0 ? { height } : void 0} {...props} />
 * A `style` key inside `...props` overwrites the height style, so we own
 * the full style merge here and skip passing the `height` prop separately.
 */
interface TextAreaFieldProps extends Omit<InputTextAreaFieldProps, 'height'> {
  height?: number;
}

export function TextAreaField({ height = 200, style, ...props }: TextAreaFieldProps) {
  return (
    <InputTextAreaField
      style={{
        height,
        border: 'none',
        ...style,
      }}
      {...props}
    />
  );
}
